/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Bottom_CenterInputs */



/**
* | output |
* | --- |
* | "Bottom Center" |
*
* @param {Input_Position_Bottom_CenterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_bottom_center = /** @type {((inputs?: Input_Position_Bottom_CenterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Bottom_CenterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Bas Centre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unten Mitte")
	if (locale === "it") return /** @type {LocalizedString} */ ("In basso al centro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нижний центр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Centro inferior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("底部中心")
	if (locale === "ja") return /** @type {LocalizedString} */ ("下中央")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निचला बीच का")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centro inferior")
	return /** @type {LocalizedString} */ ("Bottom Center")
});